export default __webpack_public_path__ + "static/media/Step.e515abce.svg";